var path = 'admin/templates/user.html';
var html = "<div>\n  <div ng-repeat=\"message in flashes.notice\" class=\"flash-notice\">\n    {{ message }}\n  </div>\n\n  <div ng-if=\"!roles.includes('ROLE_SUPER_ADMIN')\" class=\"btn-group-inline\">\n    <a href=\"/admin/user/roles\" class=\"btn-float-left\">\n      <button type=\"button\" class=\"btn btn-success btn-no-margin\">*User Roles</button>\n    </a>\n  </div>\n\n  <div ng-if=\"roles.includes('ROLE_SUPER_ADMIN')\" class=\"btn-group-inline\">\n    <a href=\"/admin/user/roles\" class=\"btn-float-left\">\n      <button type=\"button\" class=\"btn btn-success btn-no-margin\">User Roles</button>\n    </a>\n  </div>\n</div>\n\n<ui-view></ui-view>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/admin/templates/user.html
 ** module id = 294
 ** module chunks = 0
 **/